import { render, staticRenderFns } from "./OptionShape.vue?vue&type=template&id=be5bb5f8&scoped=true&"
import script from "./OptionShape.vue?vue&type=script&lang=js&"
export * from "./OptionShape.vue?vue&type=script&lang=js&"
import style0 from "./OptionShape.vue?vue&type=style&index=0&id=be5bb5f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5bb5f8",
  null
  
)

export default component.exports